import apiClient from "./axios"

export const getAccountTransactionTypeList = async (params = {}) => {
  const { data } = await apiClient.get("/account-transaction-types", { params })
  return data
}

export const getAccountTransactionTypeById = async id => {
  const { data } = await apiClient.get(`/account-transaction-types/${id}`)
  return data
}

export const createAccountTransactionType = async payload => {
  const { data } = await apiClient.post("/account-transaction-types", payload)
  return data
}

export const updateAccountTransactionType = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-transaction-types/${id}`, payload)
  return data
}

export const deleteAccountTransactionType = async id => {
  const { data } = await apiClient.delete(`/account-transaction-types/${id}`)
  return data
}
